export const RegistrationStatusTypes = {
  CLOSED: "CLOSED",
  SCHEDULED: "SCHEDULED",
  OPEN: "OPEN",
  DRAFT: "DRAFT"
};
